import { api } from '@/services';
import type { GerarLinkTemporarioPayload, GerarLinkTemporarioResponse } from '../types';

const BUCKET_PREFIX = 'imposto-cache/';

export async function gerarLinkTemporarioApi(
  payload: GerarLinkTemporarioPayload
): Promise<GerarLinkTemporarioResponse> {
  const keyNormalizada = payload.Key.startsWith(BUCKET_PREFIX)
    ? payload.Key.slice(BUCKET_PREFIX.length)
    : payload.Key;

  return api.post<GerarLinkTemporarioResponse, GerarLinkTemporarioPayload>(
    'Arquivo/GerarLinkTemporario',
    { ...payload, Key: keyNormalizada }
  );
}
